export const addTestId = (id: string) => ({ 'data-testid': id })
